import { Calendar } from 'lucide-react';
export enum ROLE {
  ADMIN = "Admin",
  EMPLOYEE = "Employee",
}

export enum ACTION {
  //FAQ Actions
  CREATE_FAQ = "CREATE_FAQ",
  EDIT_FAQ = "EDIT_FAQ",
  VIEW_ALL_FAQS = "VIEW_ALL_FAQS",
  DELETE_FAQ = "DELETE_FAQ",

  //Announcement Actions
  CREATE_ANNOUNCEMENT = "CREATE_ANNOUNCEMENT",
  EDIT_ANNOUNCEMENT = "EDIT_ANNOUNCEMENT",
  VIEW_ALL_ANNOUNCEMENTS = "VIEW_ALL_ANNOUNCEMENTS",
  DELETE_ANNOUNCEMENT = "DELETE_ANNOUNCEMENT",

  //User Actions
  CREATE_USER = "CREATE_USER",
  EDIT_USER = "EDIT_USER",
  VIEW_ALL_USERS = "VIEW_ALL_USERS",
  DELETE_USER = "DELETE_USER",

  //Contact Actions
  VIEW_ALL_CONTACTS = "VIEW_ALL_CONTACTS",

  //Embassy Message Actions
  VIEW_ALL_EMBASSY_MESSAGES = "VIEW_ALL_EMBASSY_MESSAGES",
  EDIT_EMBASSY_MESSAGE = "EDIT_EMBASSY_MESSAGE",

  //Service Actions
  CREATE_SERVICE = "CREATE_SERVICE",
  EDIT_SERVICE = "EDIT_SERVICE",
  VIEW_ALL_SERVICES = "VIEW_ALL_SERVICES",
  DELETE_SERVICE = "DELETE_SERVICE",

  //News Actions
  CREATE_NEWS = "CREATE_NEWS",
  EDIT_NEWS = "EDIT_NEWS",
  VIEW_ALL_NEWS = "VIEW_ALL_NEWS",
  DELETE_NEWS = "DELETE_NEWS"
}

class PermissionService {
  private static instance: PermissionService;

  private permissions: Record<ACTION, ROLE[]> = {
    //FAQ Permissions
    [ACTION.CREATE_FAQ]: [ROLE.ADMIN],
    [ACTION.EDIT_FAQ]: [ROLE.ADMIN],
    [ACTION.VIEW_ALL_FAQS]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.DELETE_FAQ]: [ROLE.ADMIN],

    //Announcement Permissions
    [ACTION.CREATE_ANNOUNCEMENT]: [ROLE.ADMIN],
    [ACTION.EDIT_ANNOUNCEMENT]: [ROLE.ADMIN],
    [ACTION.VIEW_ALL_ANNOUNCEMENTS]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.DELETE_ANNOUNCEMENT]: [ROLE.ADMIN],

    //User Permissions
    [ACTION.CREATE_USER]: [ROLE.ADMIN],
    [ACTION.EDIT_USER]: [ROLE.ADMIN],
    [ACTION.VIEW_ALL_USERS]: [ROLE.ADMIN],
    [ACTION.DELETE_USER]: [ROLE.ADMIN],

    //Contact Permissions
    [ACTION.VIEW_ALL_CONTACTS]: [ROLE.ADMIN, ROLE.EMPLOYEE],

    //Embassy Message Permissions
    [ACTION.VIEW_ALL_EMBASSY_MESSAGES]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.EDIT_EMBASSY_MESSAGE]: [ROLE.ADMIN],

    //Service Permissions
    [ACTION.CREATE_SERVICE]: [ROLE.ADMIN],
    [ACTION.EDIT_SERVICE]: [ROLE.ADMIN],
    [ACTION.VIEW_ALL_SERVICES]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.DELETE_SERVICE]: [ROLE.ADMIN],

    //News Permissions
    [ACTION.CREATE_NEWS]: [ROLE.ADMIN],
    [ACTION.EDIT_NEWS]: [ROLE.ADMIN],
    [ACTION.VIEW_ALL_NEWS]: [ROLE.ADMIN, ROLE.EMPLOYEE],
    [ACTION.DELETE_NEWS]: [ROLE.ADMIN]

  };

  private constructor() {}

  public static getInstance(): PermissionService {
    if (!PermissionService.instance) {
      PermissionService.instance = new PermissionService();
    }
    return PermissionService.instance;
  }

  public isAllowed(action: ACTION, role: ROLE): boolean {
    const allowedRoles = this.permissions[action] || [];
    return allowedRoles.includes(role);
  }
}

export default PermissionService; 